import ActionsForm from '@/shared/mixins/actionsForm'
import ModalAjuizamento from './modal/AjuizamentoModal.vue'
import AjuizamentoRepository from '@/shared/http/repositories/crm/ajuizamento.js'
import CardRepository from '../../../../../shared/http/repositories/crm/card'
import TextTruncate from './TextTruncate.vue'
import { toast } from '../../../../../shared/utils/UIHelper'
import MoveCardPopover from '../../components/moveCardColumn/moveCardColumn.vue'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'
import DefaultButton from '@/components/UI/button/defaultButton.vue'
import JWTService from '../../../../../shared/services/jwt'
import Roles from '@/shared/utils/roles.js'
export default {
  name: 'CrmAjuizamento',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    person: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      data: null,
      form: null,
      ajuizamento: null,
      ajuizamentos: null,
      filteredAjuizamentos: null,
      showConcluded: false,
      openMoveCardComponent: false,
      boardColumns: [],
      permissions: null,
      roles: Roles
    }
  },
  components: {
    DefaultButton,
    MoveCardPopover,
    ModalAjuizamento,
    TextTruncate
  },
  watch: {
    showConcluded () {
      this.filterAjuizamentos()
    }
  },
  computed: {
    cardActive () {
      return this.card && this.card.situacao === 'ATIVO' && !this.card.boardColumn.board.arquivado && !this.card.boardColumn.board.isReadOnly && !this.card.readOnly
    }
  },
  methods: {
    async onLoad () {
      await this.loadAjuizamentoByCard(this.card)
      this.permissions = await JWTService.GetRoles()
    },
    onReload () {
      this.$emit('Reload')
      this.loadAjuizamentoByCard(this.card)
    },
    formatDate (date) {
      if (!date) {
        return ''
      }

      const dateObj = new Date(date)
      dateObj.setDate(dateObj.getDate() + 1)

      return dateObj.toLocaleString('pt-BR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      })
    },
    async loadAjuizamentoByCard (card) {
      AjuizamentoRepository.FindAllByCardVinculado(card.id)
        .then(response => {
          this.ajuizamentos = response.data
          this.filterAjuizamentos()
        })
    },
    filterAjuizamentos () {
      this.filteredAjuizamentos = this.ajuizamentos.filter(ajuizamento =>
        this.showConcluded ? ajuizamento.concluido : !ajuizamento.concluido
      )
    },
    editAjuizamento (ajuizamento) {
      this.ajuizamento = ajuizamento
      this.$refs.ModalAjuizamento.showModal()
    },
    changeCompleteStatus (ajuizamento) {
      AjuizamentoRepository.ChangeStatus(ajuizamento.id)
        .then(response => {
          this.ajuizamento = response.data
          this.loadAjuizamentoByCard(this.card)
          toast.success('Status alterado com sucesso!')

          const isConcluded = response.data.concluido
          const messageFollowupUser = isConcluded
            ? 'O ajuizamento ' + ajuizamento.numeroProcesso + ' foi concluído. '
            : 'O ajuizamento ' + ajuizamento.numeroProcesso + ' foi reaberto.'

          createNewFollowupWithCard(
            this.card.pessoa.document,
            'sys_ajuizamento_' + (isConcluded ? 'encerrado' : 'reaberto'),
            `${messageFollowupUser}`,
            this.ip,
            this.latitude,
            this.longitude,
            this.card.id
          )
        })
        .catch(error => {
          toast.error('Erro ao alterar o status do ajuizamento.')
          console.error(error)
        })
    },
    addAjuizamento () {
      this.$refs.ModalAjuizamento.showModal()
    },
    openMoveCardModal () {
      this.openMoveCardComponent = true
    },
    movedCard (idSecondaryBoard, card, dataInicioSituacao) {
      this.$emit('movedCard', idSecondaryBoard, card, dataInicioSituacao)
    },
    unblockAjuizamento (card) {
      CardRepository.PatchUnblock(card)
        .then(response => {
          this.card = response.data
          this.loadAjuizamentoByCard(this.card)
          toast.success('Ajuizamento desbloqueado com sucesso!')
          this.$emit('Reload')
        })
        .catch(error => {
          toast.error('Erro ao desbloquear o ajuizamento.')
          console.error(error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/ajuizamento/ajuizamento.js